import React from 'react';
export function TrashLiner24(_ref) {
  let {
    size = 24
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0.899902H15M12 8.99994V19.4999M15.75 8.99994V19.4999M8.25 8.99994V19.4999M6 23.1H18C18.8284 23.1 19.5 22.4284 19.5 21.6V6.59998C19.5 5.77155 18.8284 5.09998 18 5.09998H6C5.17157 5.09998 4.5 5.77155 4.5 6.59998V21.6C4.5 22.4284 5.17157 23.1 6 23.1ZM3 5.09998H21C21.4142 5.09998 21.75 4.76419 21.75 4.34998V2.84998C21.75 2.43576 21.4142 2.09998 21 2.09998H3C2.58579 2.09998 2.25 2.43576 2.25 2.84998V4.34998C2.25 4.76419 2.58579 5.09998 3 5.09998Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }));
}